import axios from "axios";
import { IDENTITY_CONFIG } from "../../../utils/AuthConst";

const grant_type = "external_opaque";
export const client_id_external = "hub-frontend-external-opaque";
export const scopes_external =
  "openid offline_access profile hubCatalogs email";

const axiosApiRequest = axios.create({
  baseURL: IDENTITY_CONFIG.authority,
  headers: {
    "Content-Type": "application/x-www-form-urlencoded",
  },
});

export const generateToken = async (opaqueToken) => {
  return axiosApiRequest.post(
    "/connect/token",
    new URLSearchParams({
      grant_type: grant_type,
      token: opaqueToken,
      client_id: client_id_external,
      scope: scopes_external,
    }),
  );
};

export const refreshToken = async (user) => {
  return axiosApiRequest.post(
    "/connect/token",
    new URLSearchParams({
      grant_type: "refresh_token",
      client_id: client_id_external,
      refresh_token: user.refresh_token,
    }),
  );
};
